import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import IconMC from '../../components/IconMC';

const PermissionMessagePreviewMC = memo(() => {
  const { t } = useTranslation('Inbox');

  return (
    <div className="tw-w-full tw-mt-4 tw-border tw-border-gray-200 tw-rounded-lg" style={{ backgroundColor: '#F9F7F5' }}>
      <div className="tw-bg-white tw-rounded-t-lg tw-px-4 tw-py-3 tw-border-b tw-border-gray-200">
        <div className="tw-flex tw-items-center tw-justify-between">
          <div>
            <div className="tw-font-semibold tw-text-sm">Chat</div>
            <div className="tw-text-xs tw-text-gray-500">{t('wsCallSidebar.online')}</div>
          </div>
        </div>
      </div>

      <div className="tw-p-4">
        <div className="tw-max-w-sm">
          <div className="tw-bg-white tw-p-3 tw-rounded-lg tw-shadow-sm">
            <div className="tw-flex tw-items-center tw-gap-2 tw-bg-gray-100 tw-p-2 tw-rounded-lg">
              <div className="tw-bg-white tw-p-1 tw-rounded-full">
                <IconMC name="phone-outline" size="base" className="tw-text-gray-700 tw-flex-shrink-0 tw-mt-0.5" />
              </div>
              <span className="tw-text-sm tw-text-gray-950 tw-font-medium">
                {t('wsCallSidebar.callQuestion')}
              </span>
            </div>

            <div className="tw-mt-3">
              <hr className="tw-border-gray-200" />
              <div className="tw-py-3 tw-flex tw-items-center tw-justify-center tw-text-green-600 tw-text-sm tw-cursor-pointer hover:tw-bg-green-50 tw-transition-colors tw-rounded">
                <span className="tw-font-medium">{t('wsCallSidebar.allowCalls')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

PermissionMessagePreviewMC.displayName = 'PermissionMessagePreviewMC';

export default PermissionMessagePreviewMC;
